import dayjs from 'dayjs';

const getStartOfDay = (dateValue) => {
    const date = new Date(dateValue);
    date.setHours(0, 0, 0, 0);
    return date;
};

export const getMinimumBookingDate = () => {
    const minimumBookingDate = getStartOfDay(new Date());
    // minimumBookingDate.setMonth(minimumBookingDate.getMonth() + 1);
    minimumBookingDate.setDate(minimumBookingDate.getDate() + 1);
    return minimumBookingDate;
};

export const isBookingDateDisabled = (date, disabledDates = []) => {
    const formattedDate = new Date(date).toISOString();
    const calendarDate = getStartOfDay(date);

    return (
        calendarDate < getMinimumBookingDate() ||
        disabledDates.includes(formattedDate)
    );
};

export const getFirstAvailableBookingDate = (disabledDates = []) => {
    const candidateDate = getMinimumBookingDate();

    while (isBookingDateDisabled(candidateDate, disabledDates)) {
        candidateDate.setDate(candidateDate.getDate() + 1);
    }

    return dayjs(candidateDate);
};
